import React, { Fragment } from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { notificationValidations } from "./notificationConstant";
import { EMAIL_TEMPLATE_OPTIONS } from "./emailEditorUtils";
import FormInput from "../Common/FormInputs/MuiTextField";
import RichTextEditor from "../Common/FormInputs/RichTextEditor";
import { selectMenuProps } from "../../utils/selectMenuProps";

const templateSelectOptions = [
  { value: "", label: "Select template" },
  ...EMAIL_TEMPLATE_OPTIONS.map((t) => ({ value: t.id, label: t.label })),
];

const messageControlSx = {
  flex: "0 1 auto",
  minWidth: 0,
  maxWidth: { xs: "100%", md: 700 },
};
const fieldRowSx = {
  display: "grid",
  gridTemplateColumns: { xs: "1fr", md: "200px minmax(0, 700px)" },
  alignItems: "start",
  gap: 1.5,
  marginBottom: 2,
  "&:last-of-type": { marginBottom: 0 },
};
const sectionCardSx = {
  p: 2,
  mt: 1.5,
  boxShadow: 2,
  borderRadius: 1,
};

const EmailNotification = ({
  messageData = { subject: "", html: "" },
  handleMessageData,
  selectedTemplateId = "",
  handleTemplateChange,
  editorKey = 0,
}) => {
  return (
    <Fragment>
      <Typography variant="subtitle1" fontWeight={600} sx={{ mt: 2 }}>
        Message
      </Typography>
      <Paper sx={sectionCardSx}>
        <Box sx={fieldRowSx}>
          <Typography variant="body2" sx={{ fontWeight: 400, pt: { md: 1 } }}>
            Email Template:
          </Typography>
          <Box sx={messageControlSx}>
            <FormInput
              type="select"
              size="small"
              fullWidth
              value={selectedTemplateId}
              onChange={(e) => {
                if (typeof handleTemplateChange === "function") {
                  handleTemplateChange(e.target.value);
                }
              }}
              options={templateSelectOptions}
              displayEmpty
              renderValue={(v) => {
                if (!v) return "Select template";
                const match = EMAIL_TEMPLATE_OPTIONS.find((t) => t.id === v);
                return match?.label || v;
              }}
              MenuProps={selectMenuProps}
              sx={{ maxWidth: { md: 500 } }}
            />
          </Box>
        </Box>
        <Box sx={fieldRowSx}>
          <Typography variant="body2" sx={{ fontWeight: 400, pt: { md: 1 } }}>
            Subject:
          </Typography>
          <Box sx={messageControlSx}>
            <FormInput
              type="textarea"
              multiline
              rows={2}
              placeholder="Enter email subject"
              value={messageData?.subject}
              onChange={(e) => {
                handleMessageData(
                  "subject",
                  e?.target?.value?.substring(0, notificationValidations?.email?.subject?.maxLength)
                );
              }}
              sx={{ maxWidth: { md: 500 } }}
            />
            <Typography variant="caption" sx={{ display: "block", mt: 0.5 }}>
              {(messageData?.subject?.length > notificationValidations?.email?.subject?.maxLength
                ? notificationValidations?.email?.subject?.maxLength
                : messageData?.subject?.length) +
                "/" +
                notificationValidations?.email?.subject?.maxLength}
            </Typography>
          </Box>
        </Box>
        <Box sx={fieldRowSx}>
          <Typography variant="body2" sx={{ fontWeight: 400, pt: { md: 0.5 } }}>
            Body:
          </Typography>
          <Box sx={{ ...messageControlSx, width: "100%" }}>
            <RichTextEditor
              key={`email-body-${editorKey}`}
              value={messageData?.html || ""}
              onChange={(html) => handleMessageData("html", html)}
            />
          </Box>
        </Box>
      </Paper>
    </Fragment>
  );
};

export default EmailNotification;
